import React, { useEffect, useState } from 'react'
import 'feather-icons'
import styled from 'styled-components'

import TopTokenList from '../components/TokenList'
import { TYPE } from '../Theme'
import Panel from '../components/Panel'
import { useAllTokenData } from '../contexts/TokenData'
import { PageWrapper, FullWrapper } from '../components'
import { RowBetween } from '../components/Row'
import Search from '../components/Search'
import { useMedia } from 'react-use'
import { formattedNum } from '../utils'
import { useIsAdminRole } from '../hooks'
// import CheckBox from '../components/Checkbox'
// import QuestionHelper from '../components/QuestionHelper'

const DataSubText = styled.div`
  color: ${({ theme, isLimit }) => (isLimit ? theme.red1 : theme.yellow1)} !important;
  font-size: 1rem;
`

function AllTokensPage() {
  const allTokens = useAllTokenData()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const below600 = useMedia('(max-width: 800px)')

  const [useTracked, setUseTracked] = useState(false)
  const [totalTokenLiquidityUSD, setTotalTokenLiquidityUSD] = useState(0)
  const isAdmin = useIsAdminRole()

  return (
    <PageWrapper>
      <FullWrapper>
        <RowBetween>
          <TYPE.largeHeader>Top Tokens</TYPE.largeHeader>
          {isAdmin && <DataSubText>Total Liquidity(USD): {formattedNum(totalTokenLiquidityUSD)}</DataSubText>}
          {!below600 && <Search small={true} />}
        </RowBetween>
        {/* <AutoRow gap="4px">
          <CheckBox checked={useTracked} setChecked={() => setUseTracked(!useTracked)} text={'Hide untracked tokens'} />
          <QuestionHelper text="USD amounts may be inaccurate in low liquiidty pairs or pairs without ETH or stablecoins." />
        </AutoRow> */}
        <Panel style={{ marginTop: '6px', padding: below600 && '1rem 0 0 0 ' }}>
          <TopTokenList tokens={allTokens} itemMax={50} setTotalTokenLiquidityUSD={setTotalTokenLiquidityUSD} />
        </Panel>
      </FullWrapper>
    </PageWrapper>
  )
}

export default AllTokensPage
